import { Component, ElementRef, Input, OnDestroy, ViewChild } from '@angular/core';
import { NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { Store } from '@ngrx/store';
import { filter, map } from 'rxjs/operators';
import { Subject, take } from 'rxjs';
import {
  BaseAvatarSize,
  BaseButtonSize,
  BaseCoreState,
  baseInquiryActions,
  baseInquirySelectors,
  BaseModalService,
  CustomerOfferResponse,
  DocumentListItemResponseExtended,
  CustomerOfferType,
  CustomerInquiryOfferListItemWithOrder,
} from 'base';

@Component({
  selector: 'base-customer-offer-document',
  templateUrl: './base-customer-offer-document.component.html',
})
export class BaseCustomerOfferDocumentComponent implements OnDestroy {
  @Input() document: DocumentListItemResponseExtended;
  @Input() offer: CustomerOfferType | undefined;
  @ViewChild('documentViewerTemplate') documentViewerTemplate: ElementRef;
  avatarSize = BaseAvatarSize;
  buttonSize = BaseButtonSize;
  activeDocumentSrc: Blob;
  documentViewerModalRef: NgbModalRef;

  private destroy$ = new Subject();

  constructor(private store: Store<BaseCoreState>, private baseModalService: BaseModalService) {}

  ngOnDestroy() {
    this.destroy$.next(true);
  }

  downloadDocument(openInModal = false): void {
    this.cleanDocumentViewer();

    if (this.offer) {
      if (openInModal) {
        this.store
          .select(baseInquirySelectors.getDownloadDocument)
          .pipe(
            filter((state) => !!state.data),
            map((state) => state.data),
            take(1)
          )
          .subscribe((document) => {
            this.openDocumentViewer(document as Blob);
          });
      }

      this.store.dispatch(
        baseInquiryActions.downloadInquiryOfferDocument({
          payload: {
            inquiry:
              ((this.offer as CustomerInquiryOfferListItemWithOrder).inquiryId as number) ||
              ((this.offer as CustomerOfferResponse).inquiry.id as number),
            offer: this.offer.id,
            documentUuid: this.document.id,
            documentType: this.document.type,
            openInModal: openInModal,
          },
        })
      );
    }
  }

  private openDocumentViewer(document: Blob): void {
    this.activeDocumentSrc = document;
    this.documentViewerModalRef = this.baseModalService.open(
      {
        bodyTemplate: this.documentViewerTemplate,
        cancelButtonDisplayed: false,
        okButtonDisplayed: false,
        hideHeader: true,
        hideFooter: true,
      },
      { size: 'lg' }
    );
    this.documentViewerModalRef.result.then(
      () => this.cleanDocumentViewer(),
      () => this.cleanDocumentViewer()
    );
  }

  private cleanDocumentViewer() {
    this.store.dispatch(baseInquiryActions.clearDownloadInquiryOfferDocumentFile());
  }
}
